import React from 'react';
import ChatBot from 'react-simple-chatbot';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Box, BoxProps } from '../../next-components/box';
import { theme } from '../../themes/base-theme';
const chatBotTheme = {
  botBubbleColor: theme.colors.backgroundGray,
  botFontColor: theme.colors.charcoal,
  headerBgColor: theme.colors.gulfBlue,
  headerFontColor: theme.colors.white,
  userBubbleColor: theme.colors.gulfBlue,
  userFontColor: theme.colors.white,
  footerbgColor: theme.colors.white
};
export type MessageStep = {
  id: string;
  message: string | (() => void);
  delay?: number;
  component?: JSX.Element;
  asMessage?: boolean;
  placeholder?: string;
  trigger: string | number | (() => void);
  // Can pass an array of objects options
  options?: [unknown];
  end?: boolean;
};
export type UserStep = {
  id: string;
  user: boolean;
  trigger?: string | number | (() => void);
  validator?: () => void;
  placeholder?: string;
  metadata?: unknown;
  end?: boolean;
};
export type OptionsStep = {
  id: string | number;
  options?: [{
    label: string;
    value: string;
    trigger: string | number | (() => void);
  }];
  end?: boolean;
  placeholder: string;
  hideInput?: boolean;
  metadata?: unknown;
};
export type CustomStep = {
  id: string | number;
  component?: JSX.Element;
  replace?: boolean;
  waitAction?: boolean;
  asMessage?: boolean;
  trigger?: string | number | (() => void);
  delay?: number;
  end?: boolean;
  placeholder?: string;
  hideInput?: boolean;
  metadata?: unknown;
};
export type UpdateStep = {
  id?: string;
  update?: string | number;
  trigger?: string | number | (() => void);
  placeholder?: string;
  metadata?: unknown;
};
export type ChatbotProps = {
  steps: (MessageStep | UserStep | OptionsStep | CustomStep | UpdateStep)[];
  isOpen?: boolean;
  chatButtonImage?: string;
  chatHeaderImage?: string;
  header?: JSX.Element;
  avatar?: string;
  chatHeaderText?: number;
  avatarStyle?: BoxProps;
  botAvatar?: string;
  botDelay?: number;
  bubbleStyle?: BoxProps;
  contentStyle?: BoxProps;
  headerComponent?: JSX.Element;
  hideUserAvatar?: boolean;
  inputStyle?: BoxProps;
  placeholder?: string;
  style?: BoxProps;
  toggleFloating?: () => void;
  userDelay?: number;
  floatingIcon?: JSX.Element | string;
  containerProps?: BoxProps;
  botName?: string;
  bubbleOptionStyle?: BoxProps;
  cache?: boolean;
  cacheName?: string;
  className?: string;
  customDelay?: number;
  customStyle?: BoxProps;
  controlStyle?: BoxProps;
  enableMobileAutoFocus?: boolean;
  enableSmoothScroll?: boolean;
  extraControl?: JSX.Element;
  floating?: boolean;
  floatingStyle?: BoxProps;
  footerStyle?: BoxProps;
  handleEnd?: boolean;
  headerTitle?: string;
  height?: string;
  hideBotAvatar?: boolean;
  hideHeader?: boolean;
  hideSubmitButton?: boolean;
  inputAttributes?: unknown;
  opened?: boolean;
  recognitionEnable?: boolean;
  recognitionLang?: string;
  recognitionPlaceholder?: string;
  speechSynthesis?: {
    enable?: boolean;
    lang?: string;
    voice?: unknown;
  };
  submitButtonStyle?: BoxProps;
  userAvatar?: string;
  width?: string;
};
export const Chatbot = ({
  steps,
  isOpen,
  containerProps,
  floatingStyle,
  style,
  ...rest
}: ChatbotProps) => <ThemeProvider theme={chatBotTheme} data-sentry-element="ThemeProvider" data-sentry-component="Chatbot" data-sentry-source-file="Chatbot.tsx">
    <ChatBotGlobalStyle data-sentry-element="ChatBotGlobalStyle" data-sentry-source-file="Chatbot.tsx" />
    <Box {...containerProps} data-sentry-element="Box" data-sentry-source-file="Chatbot.tsx">
      <ChatBot opened={isOpen} floating steps={steps} floatingStyle={{
      display: 'contents',
      marginRight: '10px',
      ...floatingStyle
    }} style={{
      height: 'auto',
      ...style
    }} {...rest} data-sentry-element="ChatBot" data-sentry-source-file="Chatbot.tsx" />
    </Box>
  </ThemeProvider>;
const ChatBotGlobalStyle = createGlobalStyle`
  .rsc-input::placeholder {
    color: ${theme.colors.darkGray};
  }
  .rsc-content, .rsc-footer {
    background-color: ${theme.colors.white};
  }
  .rsc-content {
    margin-top: unset;
  }
`;